import React from 'react';
import './page.css';

const WIDTHS = ['default', 'wide', 'narrow'];

/**
 * Outermost wrapper of every page. AppLayout already pads the content area (24px), so this adds
 * no horizontal padding: it only centres the page and caps its width.
 */
const PageShell = ({ width = 'default', children, className = '', ...rest }) => {
  const w = WIDTHS.includes(width) ? width : 'default';
  return (
    <div className={`pl-page-shell pl-page-shell--${w} ${className}`.trim()} data-testid="page-shell" {...rest}>
      {children}
    </div>
  );
};

export default PageShell;
